export default __webpack_public_path__ + "static/media/ellipse-2.ed8e99e7.svg";